import { createTAL } from './io-helpers';

class EdfAnnotationWriter {
    /**
     * @param {Array.<Annotation>} annotations
     */
    static createTals(annotations) {
        return annotations.map((annotation) => createTAL(annotation));
    }

    /**
     *
     * @param {Array.<Annotation>} annotations
     * @param {string} filename
     */
    static createFile(annotations, filename) {
        return new File(
            [new Blob([EdfAnnotationWriter.createTals(annotations).join('')], {})],
            filename
        );
    }
}

export default EdfAnnotationWriter;
